import { Route } from "react-router-dom";
import CompaniesScreen from "../../../container/System/CompaniesScreen";
import CreateCompaniesContainer from "../../../container/System/CompaniesScreen/CreateCompanies";
import { APP_URLS } from "../../../utils/constant";

const CompaniesRoutes = (access = {}) => {
  const { view = false, create = false, edit = false } = access;
  const screenPermissions = { view, create, edit };

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.SYSTEM_COMPANIES.HOME}
          element={<CompaniesScreen screenPermissions={screenPermissions} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.SYSTEM_COMPANIES.CREATE}
          element={<CreateCompaniesContainer />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.SYSTEM_COMPANIES.EDIT}
          element={<CreateCompaniesContainer isEdit={true} />}
        />
      )}
    </>
  );
};

export default CompaniesRoutes;
